import { Guid } from 'guid-typescript';
import { Constants } from '../../../constants';

export class MenuItem
{
    constructor(title:string , icon :string, permission :string ,  route:string, key:string="", loggedIn:boolean = true)
    {
        this.id = Guid.create().toString();
        this.title = title;
        this.icon = icon == null || icon =="" || icon == "undefined" ? Constants.menu_icon :icon;
        this.permission = permission;
        this.route = route;     
        this.loggedIn = loggedIn;

        if (key ==""){
            this.key = this.id;
        }else{
            this.key = key;
        }
    }
    id : string;
    title :string;
    icon : string;
    permission : string;
    route : string;
    loggedIn : boolean;
    key : string;
    submenus : Array<MenuItem> = new Array<MenuItem>();
}